import { css } from '@emotion/react'
import { Text, VFlow } from 'bold-ui'

interface SdcSecaoAlertaProps {
  titulo?: string
  conteudo?: string
  children?: React.ReactNode
  paddingConteudo?: boolean
}

export const SdcSecaoAlerta = (props: SdcSecaoAlertaProps) => {
  const { titulo, conteudo, children, paddingConteudo = false } = props

  if (!conteudo) return null

  const styles = createStyles(paddingConteudo)

  return (
    <VFlow vSpacing={0.5}>
      {titulo && <Text variant='h4' dangerouslySetInnerHTML={{ __html: titulo }} />}
      {conteudo && (
        <div css={styles.conteudoTextHtml}>
          <Text component='div' dangerouslySetInnerHTML={{ __html: conteudo }} />
        </div>
      )}
      {children}
    </VFlow>
  )
}
const createStyles = (paddingConteudo: boolean) => ({
  conteudoTextHtml: css`
    padding: 0 ${paddingConteudo ? 1 : 0}rem;

    p:not(:first-of-type) {
      margin-top: 0.5rem;
    }

    p + ul {
      margin-top: 0.5rem;
    }

    ul {
      margin: 0;
      list-style: none;
      padding-left: 0.5rem;
    }

    li {
      display: block;
    }

    li::before {
      content: '•';
      display: inline-flex;
      width: 1ch;
      margin-right: 0.5rem;
    }

    ul > li:not(:first-of-type):not(ul ul > li) {
      margin-top: 0.5rem;
    }

    ul ul > li {
      margin-top: 0.5rem;
    }

    ul ul {
      padding-left: 1rem;
    }

    ul > li > .atencaoBox {
      margin-left: calc(1ch + 0.313rem);
      margin-top: 0.5rem;
    }

    .quebraLinha + p {
      margin-top: 0;
    }
  `,
})
